import List from "./ListPage";
import Create from "./CreatePage";
import Edit from "./EditPage";
import Show from "./ShowPage";

const resource = {
  list: List,
  create: Create,
  edit: Edit,
};

export default resource;
